/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import Modal from '../Modal';
import { shallowEqual, useSelector } from 'react-redux';
import Icon from '../Icon';
import SearchIcon from "../../assets/images/icon/search-icon2.svg";
import Input from '../Input';
import IconButton from '../Button/IconButton';
import CloseButton from "../../assets/images/icon/close-btn.svg";
import { classnames } from '../../utils/text';
import Button from '../Button';
import { isEmpty } from '../../utils/lodashExtend';
import PerfectScrollbar from "react-perfect-scrollbar";
import { ControlTable } from '../Table';


const CareCompaniesModal = ({
  isOpen,
  setIsOpen,
  selectedCareCompany,
  setSelectedCareCompany
}) => {
  const { careCompanies, employee } = useSelector(
    (store) => ({
      careCompanies: store.Data.careCompanies,
      employee: store.Profile.employee,
    }),
    shallowEqual
  );

  const [searchText, setSearchText] = useState("");
  const [selectedList, setSelectedList] = useState(selectedCareCompany);
  const [list, setList] = useState(careCompanies);
  const [fields] = useState([
    { title: "회사명", key: "name" },
    { title: "대표명", key: "ceoName" },
    {
      title: "주담당자",
      key: "managers",
      onValue: (data) => {
        let count = 0;
        return (
          !isEmpty(data) &&
          // eslint-disable-next-line array-callback-return
          data.map((manager, idx) => {
            if (manager?.companyManagerPerson?.level === 1) {
              if (count === 0) {
                count++;
                return manager.name;
              } else {
                return ',' + manager.name;
              }
            }
          }
          ));
      }
    },
    { title: "사업자번호", key: "comNum", transform: "comNum", },
  ]);

  const [checked, setChecked] = useState(false);
  const close = () => {
    setChecked(false);
    setIsOpen(false);
  };

  const _setSearchText = (e) => {
    setSearchText(e.target.value);
  };

  const searchCareCompanyResult = useCallback(
    ({ name }) => {
      return name.includes(searchText);
    },
    [searchText]
  );
  const isSelectedCareCompany = (company) => {
    return !!selectedList.find((e) => {
      return e.companyIdx === company.companyIdx;
    });
  };

  const handleRemove = (data) => {
    _setSelectedList(
      selectedList.filter((selected) => selected.companyIdx !== data.companyIdx)
    );
  };

  const handleRemoveAll = () => {
    _setSelectedList();
  };

  const _setSelectedList = (companies = []) => {
    setSelectedList(companies);
  };

  const _submit = () => {
    setSelectedCareCompany(selectedList);
    close();
  };

  const handleOnChecked = () => setChecked(!checked);

  const [headerButtons, setHeaderButtons] = useState([]);

  useEffect(() => {
    setHeaderButtons([{
      type: "checkbox",
      label: "주담당 관리회사만 보기",
      checked,
      key: 'checked',
      onChange: handleOnChecked
    }]);

    if (checked) {
      setList(careCompanies.filter(company => {
        return company?.managers?.find(f => f.idx === employee?.employeeIdx && f?.companyManagerPerson?.level === 1);
      }));
    } else {
      setList(careCompanies);
    }
  }, [checked]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        close={close}
        className="search-care-companies"
      >
        <div className="search-care-companies-filter">
          <div className="search-care-companies-header">
            <h5 className="search-care-companies-title">관리중인 회사 목록</h5>
          </div>
          <div className="search-care-companies-body">
            <div className="search-text-wrap">
              <Icon src={SearchIcon} />
              <Input
                name={"search-text"}
                placeholder={"회사명 검색"}
                value={searchText}
                onChange={_setSearchText}
                className={"search-text-input"}
              />
              {searchText && (
                <IconButton
                  className="search-input-delete-icon"
                  icon={CloseButton}
                  onClick={() => setSearchText("")}
                />
              )}
            </div>

            {searchText && (
              <ul className="tab-list">
                <li className="tab-item">
                  "<span className="color-main-100">{searchText}</span>" 검색결과
                </li>
              </ul>
            )}
            {searchText && (
              <div className="search-result-container">
                <ul className="search-result-wrap">
                  {careCompanies.map((company, idx) => {
                    return (
                      <li
                        className={classnames("text-search-company", {
                          alive: searchCareCompanyResult(company),
                          hide: !searchCareCompanyResult(company),
                          selected: isSelectedCareCompany(company),
                        })}
                        key={idx}
                        onClick={() => {
                          if (isSelectedCareCompany(company)) {
                            handleRemove(company);
                          } else {

                            selectedList.push(careCompanies.find(f => f.companyIdx === company.companyIdx));
                            _setSelectedList([...selectedList]);
                          }
                        }}
                      >
                        <span className="company-wrap inline-block">{company.name}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            <div className={classnames("table-view-wrap", { selected: !isEmpty(selectedList) })}>
              <ControlTable
                isControl
                selectedList={selectedList}
                setSelected={(d) => {
                  setSelectedList(d);
                }}
                fields={fields}
                list={list}
                isHidePagination={true}
                buttons={headerButtons}
              />
            </div>

            {!isEmpty(selectedList) && (
              <div className="selected-list-wrap">
                <div className="list-wrap">
                  <PerfectScrollbar>
                    {!isEmpty(selectedList) &&
                      selectedList.map((data, idx) => {
                        return (
                          <span key={idx} className="selected-tag">
                            {data.name}
                            <IconButton
                              className="close-btn"
                              icon={CloseButton}
                              onClick={(e) => handleRemove(data)}
                            />
                          </span>
                        );
                      })}
                  </PerfectScrollbar>
                </div>

                <div className="remove-btn-wrap">
                  <div className="backgound"></div>
                  <Button
                    className="remove-all"
                    label="전체삭제"
                    color="text"
                    onClick={handleRemoveAll}
                  />
                </div>
              </div>
            )}
          </div>



          {(close || setSelectedCareCompany) && (
            <div className="search-care-companies-footer">
              <div className="search-button-wrap">
                {close && (
                  <Button className="button" color={"text"} onClick={close}>
                    취소
                  </Button>
                )}
                {setSelectedCareCompany && (
                  <Button onClick={_submit} className="button">
                    선택완료
                  </Button>
                )}
              </div>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default CareCompaniesModal;